import styled from 'styled-components';
import color from 'tinycolor2';
import { Button, Chip } from '@pearsontechnology/aero-components';

export const StyledChip = styled(Chip)`
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  padding: 0px 14px;
  background: ${(props) => props.isChapterDisabled ? 'white' : props.background};
  color: ${(props) => props.isChapterDisabled ? props.theme['color.overlay.text.toast'] : props.color};
`;

export const WrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;

export const TextWrapper = styled.div`
    width: 100%;
    padding-right: 1.5px;
    padding-left: 3px;
`;

export const StyledParagraph = styled.p`
  font-size: 11px;
  margin: 0px;
  padding-top: 5px;
`;

const getbackgroundColor = (props, defaultColor) => {
  if (props.color) {
    return props.color;
  }
  return defaultColor;
};

export const StyledButton = styled(Button)`
  left: 4px;
  &:hover {
    background-color: ${(props) =>
    color(getbackgroundColor(props, props.theme['color.orangeLight']))
      .setAlpha(0.2)
      .toString()} !important ;
  }

  &:focus {
    background-color: ${(props) =>
    props.show
      ? color(getbackgroundColor(props, props.theme['color.orangeLight']))
        .setAlpha(0.2)
        .toString()
      : props.theme['color.surface']};
  }

  &:focus {
    box-shadow: 0 0 0 4px
      ${(props) =>
    props.show
      ? color(getbackgroundColor(props, props.theme['color.orangeLight']))
        .setAlpha(0.4)
        .toString()
      : props.theme['color.surface']};
  }
`;
